export default {
  AboutCyborCoin: "Информация о PayCrypt Coin",
  BlockchainBusiness: "Блокчейн-технологии для вашего бизнеса",
  AboutPara:
    "Для безопасных и анонимных транзакций между пользователями платформы Cyborex и платёжной системы PayCrypt, компания PayCrypt создала сильный бренд на рынке криптовалют, разработав и запустив собственную криптовалюту PayCrypt Coin.",
};
